export default __webpack_public_path__ + "static/media/paneer.399e1998.jpg";